/**
 * Shuffle items from the given array.
 *
 * @param  {Array} as - the target array
 *
 * @return {Array} The shuffled array.
 */
export default function shuffle(as) {
  if (!as) return [];
  const tempAs = [...(as || [])];
  let currentIndex = tempAs.length;
  let temporaryValue;
  let randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = tempAs[currentIndex];
    tempAs[currentIndex] = tempAs[randomIndex];
    tempAs[randomIndex] = temporaryValue;
  }
  return tempAs;
}
